export default __webpack_public_path__ + "static/media/linkedin-white.bd734248.svg";